import React from 'react';
import Image from 'next/image';
import { IconSymbolResponsiveSizeType, IconSymbolSizeType } from '../../../../theme/type/icon-symbol-type';
import { SymbolTypeEnum } from '../../../../defs/api';
import { cn } from '../../../../utils/tailwind';
import { getSymbolSizeClasses, symbolImageSizeClass, symbolWrapperSizeClass } from './symbol-icon-size';

interface SymbolIconProps {
    symbol: string | undefined;
    size?: IconSymbolSizeType | IconSymbolResponsiveSizeType;
    type?: SymbolTypeEnum | null;
    border?: boolean;
    shadow?: boolean;
}

export const SymbolIcon: React.FC<SymbolIconProps> = ({
    symbol,
    size = 'medium',
    border = true,
    shadow = true,
    type,
}) => {
    const wrapperSizeClass = getSymbolSizeClasses(size, symbolWrapperSizeClass);
    const innerSizeClass = getSymbolSizeClasses(size, symbolImageSizeClass);

    return (
        <div
            className={cn(
                'inline-flex items-center justify-center overflow-hidden bg-neutral-white text-small font-black not-italic leading-small text-text-muted',
                wrapperSizeClass,
                border && 'rounded-small border border-solid border-border',
                shadow && 'shadow-soft',
            )}
        >
            <div className={cn('relative', innerSizeClass)}>
                {symbol && (
                    <Image
                        src={`${process.env.NEXT_PUBLIC_API_URL}/logo/${encodeURIComponent(symbol)}${
                            type ? `?type=${type}` : ''
                        }`}
                        layout="fill"
                        objectFit="contain"
                        alt={symbol}
                    />
                )}
            </div>
        </div>
    );
};
